<template>
  <div class="404 has-background-white-bis fixspace">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <img
            :src="'https://upload.wikimedia.org/wikipedia/commons/5/52/Crotchet_rest_alt_plain-svg.svg'"
            alt="Musian"
            class="is-hidden-mobile mb-5"
            style="
              display: block;
              margin-left: auto;
              margin-right: auto;
              width: 2%;
            "
          />
          <img
            :src="'https://upload.wikimedia.org/wikipedia/commons/5/52/Crotchet_rest_alt_plain-svg.svg'"
            alt="Musian"
            class="is-hidden-desktop is-hidden-tablet-only mb-5"
            style="
              display: block;
              margin-left: auto;
              margin-right: auto;
              width: 6%;
            "
          />
          <h1 class="has-text-black is-size-1-desktop is-size-2-mobile"
            style="font-weight:900;">
            404
          </h1>
          <p class="has-text-black is-size-5-desktop is-size-6-mobile pt-3 pb-6">
            {{ $t('404.msg') }}
          </p>
          <b-button type="is-black"
              size="is-medium"
              tag="router-link"
              class="mx-1 px-5 is-size-6"
              to="/search">
              {{ $t('404.back') }}
          </b-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: '404',

  metaInfo() {
    return {
      title: this.$t('title.pagenotfound'),
    };
  },

  mounted() {
    this.forGtag();
  },

  beforeDestroy() {
    clearTimeout(this.timer);
  },

  methods: {
    forGtag() {
      this.timers = setTimeout(() => {
        this.$emit('forGtagStatus', this.$t('title.pagenotfound'));
      }, 500);
    },
  },
};
</script>
